import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AlertData {
	title: string;
	subtitle?: string;
	checkbox?: {
		title: string;
		value: boolean;
	};
	confirmButtonText?: string;
	cancelButtonText?: string;
	loading?: boolean;
	show?: boolean;
	response?: string;
	showInput?: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class AlertInputService {
	data!: AlertData;
	public open = new Subject<AlertData>();
	public confirm = new Subject<any>();

	// Instantiate and initialize the alert
	// @autor: Carlos Sánchez Mora
	// @date: 02-08-2022
	initiate(data: AlertData): any {
		if (!data.cancelButtonText) {
			data.cancelButtonText = 'Regresar';
		}
		this.data = { ...data, show: true, loading: false };
		this.open.next(this.data);
	}

	// Set loading state
	setLoading(loading: boolean): void {
		if (this.data) {
			this.data.loading = loading;
		}
	}

	// Close the alert
	// @autor: Carlos Sánchez Mora
	// @date: 02-08-2022
	hide(res: any): any {
		this.data = { ...this.data, show: false, loading: false };
		this.open.next(res);
	}
}
